// extracted by mini-css-extract-plugin
export default {"content_container":"UserList_content_container__kwkgl","list__content":"UserList_list__content__SZp8T","content":"UserList_content__Lpdli"};